// Story 7.15 (ADO-1372): the PDP's VAT rate as a percentage. Moved here from `ProductPanels`
// by Story 11.10 (ADO-1961), so the margin info panel formats the rate as the VAT row does.

/**
 * Story 7.15 (ADO-1372), D-8 — the stored value is a MULTIPLIER, not a percentage:
 * `'1.23'` means 23% VAT. Derived exactly as SL1.0 does
 * (`vatRateDisplay = (VatRate - 1) * 100`, `get_smanager.php:4017-4018`).
 *
 * ⚠️ The absence guard is `=== null`, NOT falsiness. A `1` multiplier is a genuine
 * ZERO-RATED product and must render `0%`; a falsy check would make it vanish and
 * silently claim "no VAT information" about a product that has some.
 *
 * A multiplier BELOW 1 is not zero-rated, it is nonsense — `(0 - 1) * 100` is `-100`,
 * and a PDP must not print a negative tax rate. The primary defence is catalogue's
 * activation merge, which publishes a rate outside [1, 2] as null and reports it
 * (Enabler E7-A, ADO-2272, D-13), so such a value never reaches the product page from
 * the feed. This second guard covers any other producer: out-of-domain rates are
 * OMITTED (AC3) rather than displayed. An earlier
 * version of this file — and of D-8 — claimed `0` was a legitimate zero-rated
 * multiplier; it is not, and the claim is deleted rather than softened.
 *
 * The rounding is not cosmetic: `(1.23 - 1) * 100` is `22.999999999999996` in IEEE
 * doubles, so an unrounded render would read "22.999999999999996%".
 */
export function formatVatRate(rate: string | null): string | null {
  if (rate === null) return null;
  const multiplier = Number(rate);
  if (!Number.isFinite(multiplier)) return null;
  if (multiplier < 1 || multiplier > 2) return null;
  const percent = Math.round((multiplier - 1) * 100 * 100) / 100;
  return `${percent}%`;
}
